import {
  DbotEvent,
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import { DecisionType } from "@/common/decisions";
import { ChangeBusinessPurpose, ChangeBusinessPurposeForm } from "./changeBusinessPurposeDomain";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<ChangeBusinessPurpose>,
  data?: ChangeBusinessPurpose,
): ChangeBusinessPurposeForm {
  return new ChangeBusinessPurposeForm(dispatch, context, data);
}

export function applyForm(form: ChangeBusinessPurposeForm): ChangeBusinessPurpose {
  return {
    type: DecisionType.changeBusinessPurpose,
    paragraph: form.paragraph.selected,
    texts: form.texts.map((m) => ({
      text: m.model.validatedValue,
      language: m.locale,
    })),
  };
}

export function handleEvent(form: ChangeBusinessPurposeForm, event: DbotEvent) {
  form.handleEvent(event);
}

export function validate(form: ChangeBusinessPurposeForm): boolean {
  return form.validate();
}

export function isValid(form: ChangeBusinessPurposeForm): boolean {
  return form.isValid;
}

export const changeBusinessPurposeHandler: DecisionTypeHandler<
  DecisionType.changeBusinessPurpose,
  ChangeBusinessPurpose,
  ChangeBusinessPurposeForm
> = {
  type: DecisionType.changeBusinessPurpose,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent,
};
